document.addEventListener('DOMContentLoaded', () => {
  const progressBar = document.querySelector('.article-progress-bar');
  const articleEl = document.querySelector('.article-template');

  if (progressBar && articleEl) {
    const updateProgress = () => {
      const rect = articleEl.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const progress = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;
      progressBar.style.transform = `scaleX(${progress})`;
    };

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  }

  const copyButtons = document.querySelectorAll('.article-share-copy');
  copyButtons.forEach((button) => {
    let hideTimer = null;

    button.addEventListener('click', () => {
      const url = button.dataset.shareUrl;
      if (!url || !navigator.clipboard) return;

      navigator.clipboard.writeText(url).then(() => {
        button.classList.add('is-copied');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          button.classList.remove('is-copied');
        }, 2000);
      });
    });
  });
});
